import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'database-breed-type-classification',
  templateUrl: './database-breed-type-classification.component.html',
  styleUrls: ['./database-breed-type-classification.component.scss']
})
export class DatabaseBreedTypeClassificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
